import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";

const focusPrimary =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-teal-600)]/40 focus-visible:ring-offset-2";

const focusSecondary =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-primary)]/35 focus-visible:ring-offset-2";

const focusGhost =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)]/35 focus-visible:ring-offset-2";

/** Standardized button surfaces (also used by {@link Button}). */
export const buttonVariants = {
  primary: cn(
    "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[var(--color-teal-600)] px-8 py-3 font-semibold text-white shadow-sm touch-manipulation",
    "transition duration-300 ease-in-out",
    "hover:-translate-y-0.5 motion-reduce:hover:translate-y-0 hover:bg-[var(--color-teal-700)] hover:shadow-md hover:shadow-[0_10px_28px_-6px_rgba(8,145,178,0.38)]",
    "active:translate-y-0",
    focusPrimary,
  ),
  secondary: cn(
    "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg border-2 border-[var(--color-primary)] bg-transparent px-8 py-3 font-semibold text-[var(--color-primary)] touch-manipulation",
    "transition duration-300 ease-in-out",
    "hover:bg-[var(--color-primary)] hover:text-white",
    focusSecondary,
  ),
  ghost: cn(
    "inline-flex items-center justify-center gap-2 rounded-lg bg-transparent px-8 py-3 font-semibold text-[var(--color-accent)]",
    "transition duration-300 ease-in-out",
    "hover:bg-slate-50",
    focusGhost,
  ),
};

export function PrimaryLink({ to, href, className, children, ...rest }) {
  const cls = cn(buttonVariants.primary, className);
  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} className={cls} {...rest}>
      {children}
    </a>
  );
}

export function SecondaryLink({ to, href, className, children, ...rest }) {
  const cls = cn(buttonVariants.secondary, className);
  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} className={cls} {...rest}>
      {children}
    </a>
  );
}

export function GhostLink({ to, href, className, children, ...rest }) {
  const cls = cn(buttonVariants.ghost, className);
  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} className={cls} {...rest}>
      {children}
    </a>
  );
}
